import ApplicationUrlConfiguration from './ApplicationUrlConfiguration';

export default ApplicationUrlConfiguration;
